import { ReactElement } from 'react'
import TemplatesV3 from '../template'

export default (): ReactElement => <TemplatesV3 />
